import { getInstance as getDSInstance } from 'modules/api/digitalServices/instance';
import axios from 'axios';

export async function uploadBrokerLogo(brokerLogo: File | string): Promise<string> {
  if (typeof brokerLogo !== 'string') {
    const fileType = brokerLogo.type;
    const fileTypeParts = fileType.split('/');

    const { data } = await getDSInstance().post('/template-builder/upload/broker-logo', {
      contentType: fileType,
      fileExtension: fileTypeParts[fileTypeParts.length - 1],
    });

    await axios.put(data.uploadUrl, brokerLogo, {
      headers: {
        'Content-Type': brokerLogo.type,
      }
    });

    return data.finalS3Url;
  }

  return '';
}

export async function uploadHeadshot(headshot: File | string): Promise<string> {
  if (typeof headshot !== 'string') {
    const fileType = headshot.type;
    const fileTypeParts = fileType.split('/');

    const { data } = await getDSInstance().post('/template-builder/upload/headshot-image', {
      contentType: fileType,
      fileExtension: fileTypeParts[fileTypeParts.length - 1],
    });

    await axios.put(data.uploadUrl, headshot, {
      headers: {
        'Content-Type': headshot.type,
      }
    });

    return data.finalS3Url;
  }

  return '';
}
